export const trustBudTokens = {
  colors: {
    bg: {
      app: "#f3f6fa",
      canvas: "#f7f9fc",
      paper: "#ffffff",
      paperMuted: "#f8fafc",
      strong: "#10213a",
      strongAlt: "#152944",
    },
    text: {
      primary: "#102033",
      secondary: "#39516d",
      muted: "#70839a",
      inverse: "#f8fbff",
      inverseMuted: "rgba(248, 251, 255, 0.72)",
    },
    border: {
      subtle: "#d7e2ee",
      muted: "#c7d4e2",
      strong: "#9fb1c4",
      inverse: "rgba(255,255,255,0.14)",
    },
    brand: {
      navy900: "#0c1a2e",
      navy800: "#102544",
      navy700: "#17345d",
      navy600: "#254b79",
      teal500: "#2e8b76",
      teal300: "#8fd2c1",
    },
    success: {
      base: "#2d8a5f",
      strong: "#1b6a48",
      soft: "#e6f4ec",
      text: "#174b34",
    },
    warning: {
      base: "#c47a22",
      strong: "#8a5312",
      soft: "#fff2df",
      text: "#6e4311",
    },
    danger: {
      base: "#cf5a5f",
      strong: "#a1363d",
      soft: "#fdeaea",
      text: "#7f1d1d",
    },
  },
  radius: {
    xs: 4,
    sm: 6,
    md: 8,
    lg: 10,
    xl: 12,
    pill: 999,
  },
  shadows: {
    soft: "0 1px 2px rgba(15, 23, 42, 0.04)",
    card: "0 8px 18px rgba(15, 23, 42, 0.045)",
    hero: "0 14px 28px rgba(10, 18, 33, 0.12)",
  },
};

export function getStateTone(state) {
  if (state === "active") {
    return {
      heroBackground: "#f4fbf7",
      heroBorder: "#dcefe4",
      chipBg: "#e9f8ef",
      chipColor: "#16924e",
      ringColor: "#5ac5a3",
      primaryButtonBg: "#13233d",
      primaryButtonText: "#f8fbff",
    };
  }
  if (state === "drift") {
    return {
      heroBackground: "#fff6ea",
      heroBorder: "#f4dec2",
      chipBg: "#fff1df",
      chipColor: "#f07a11",
      ringColor: "#d9a15b",
      primaryButtonBg: "#13233d",
      primaryButtonText: "#f8fbff",
    };
  }
  if (state === "reentry") {
    return {
      heroBackground: "#effaf3",
      heroBorder: "#d8ecdf",
      chipBg: "#e5f6ec",
      chipColor: "#198754",
      ringColor: "#71c793",
      primaryButtonBg: "#13233d",
      primaryButtonText: "#f8fbff",
    };
  }
  return {
    heroBackground: "#f7f8fb",
    heroBorder: "#e1e7ef",
    chipBg: "#eef2f7",
    chipColor: "#6b7c91",
    ringColor: "#9db3ca",
    primaryButtonBg: "#13233d",
    primaryButtonText: "#f8fbff",
  };
}
